var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"context-menu",attrs:{"data-testid":"context-menu"}},_vm._l((_vm.options),function(option){return _c('li',{key:option.text,staticClass:"context-menu__item",on:{"mousedown":option.action}},[_vm._v(" "+_vm._s(option.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }